import { cardMediaClasses } from "@mui/material"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing, palette }) => ({
  contentLoadingContainer: {
    padding: spacing(7, 4),
    borderRadius: "3px",
    backgroundColor: palette.primary[50]
  },
  loaderContainer: {
    "& > div": {
      margin: spacing(0),

      [`& .${cardMediaClasses.root}`]: {
        width: "100px",
        height: "57px"
      }
    }
  }
}))
